import React, { useCallback, useMemo } from 'react'
import { Button, feedbackcard, YesObject } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { useLocation, useNavigate } from 'react-router-dom'
import { TaskButtonsProps } from './types'
import { STATUS_MAPPING } from './constants'

function TaskButtons({ status, tasks }: TaskButtonsProps) {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const relativeEncodedUrl = encodeURIComponent(
    location.pathname + location.search + location.hash
  )

  const tasksByCode = useMemo(() => {
    const tasksMap: Record<string, YesObject[]> = {}

    if (!tasks) return tasksMap

    tasks.forEach((task) => {
      if (!task.complement) return
      ;(tasksMap[task.complement] ??= []).push(task)
    })

    return tasksMap
  }, [tasks])

  const handleAction = useCallback(
    (code: string, label: string) => () => {
      const action = label.split('.')[1]
      const taskToBeExecuted = tasksByCode[code].find(
        (task) => task.obs === action
      )

      if (!taskToBeExecuted) {
        feedbackcard(t('generic-error'), { type: 'error' })
        return
      }

      const params = new URLSearchParams({
        taskUuid: taskToBeExecuted.uuid,
        returnUrl: relativeEncodedUrl,
        returnOnFinish: 'true'
      })

      navigate({
        pathname: `/${window.taskExecutorSitemodelUuid}`,
        search: params.toString()
      })
    },
    [navigate, relativeEncodedUrl, t, tasksByCode]
  )

  if (!status || !tasks || tasks?.length === 0) return null

  const buttons = STATUS_MAPPING[status.code]

  if (!tasksByCode[status.code]) return null

  return (
    <>
      {buttons.map((button) => (
        <Button
          key={button.label}
          variant={button.type}
          onClick={handleAction(status.code, button.label)}
          className='mb-2'
          heightClass='semiSmall'
        >
          {t(button.label)}
        </Button>
      ))}
    </>
  )
}

export default TaskButtons
